"use client";

import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { IRenewTotal } from "@/interfaces/renew.interfaces";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import { RenewMessages } from "@/messages/renew/renew.messages";

import ProductInfoCard from "./components/ProductInfoCard";
import RenewFormCard from "./components/RenewFormCard";

type Props = {
  messages: RenewMessages;
  isLoading: boolean;
  salesProduct: ISalesProduct;
  salesProductPrice: ISalesProductPrice;
  totalPayment: IRenewTotal;
};

function RenewForm({ messages, isLoading, salesProduct, salesProductPrice, totalPayment }: Props) {
  return (
    <MDBox>
      <MDBox my={3}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 7 }}>
            <MDBox height={"100%"}>
              <RenewFormCard messages={messages} isLoading={isLoading} />
            </MDBox>
          </Grid>
          <Grid size={{ xs: 12, lg: 5 }}>
            <MDBox height={"100%"}>
              <ProductInfoCard
                messages={messages}
                salesProduct={salesProduct}
                salesProductPrice={salesProductPrice}
                totalPayment={totalPayment}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default RenewForm;
